export default "__VITE_ASSET__zNy3XDwQ__"